import { createSlice } from '@reduxjs/toolkit';
import { MenuBoardDataSlice } from '../../menu-board/store/dataSlice';

const initialState: initialStateType = {
  menuDialog: false,
  editMenuDialog: false,
  editMenuData: null,
};

const stateSlice = createSlice({
  name: 'menuDialog/state',
  initialState: initialState,
  reducers: {
    toggleMenuDialog: (state, action) => {
      state.menuDialog = action.payload;
    },
    toggleEditMenuDialog: (state, action) => {
      state.editMenuDialog = !!action.payload;
      state.editMenuData = action.payload;
    },
  },
});

export const { toggleMenuDialog, toggleEditMenuDialog } = stateSlice.actions;
export default stateSlice.reducer;
interface initialStateType {
  menuDialog: boolean;
  editMenuDialog: boolean;
  editMenuData: MenuBoardDataSlice['menu'];
}
